/**
 * @name decimalToHex
 */
export const decimalToHex = (decimal: number): string => decimal.toString(16);
